import React from 'react';
import { Pane, BackButton, toaster } from 'evergreen-ui';
import PageHeader from 'components/shared/PageHeader';
import CreateOrUpdateHospital from 'components/admin/CreateOrUpdateHospital';
import { LIST_HOSPITALS_PATH } from '../paths';

export default ({ history }: any) => {
  return (
    <>
      <PageHeader
        title="Create new hospital"
        renderButtons={
          <BackButton
            marginLeft="auto"
            onClick={() => history.push(LIST_HOSPITALS_PATH)}
          />
        }
      />

      <Pane width="500px">
        <CreateOrUpdateHospital
          onComplete={() => {
            toaster.success('Hospital successfully created');
            history.push(LIST_HOSPITALS_PATH);
          }}
        />
      </Pane>
    </>
  );
};
